export const menuData = [
  { title: 'Home', link: '/' },
  { title: 'About Us', link: '/about' },
  { title: 'Properties', link: '/properties' },
];
